import { proxy } from "valtio";

/**
 * Id widget katalog yang sedang tampil di `/wall`. Diisi WallPage, dibaca asisten
 * saat mengirim pertanyaan agar tahu apa yang ada di layar. Kosong di luar /wall.
 */
export const wallVisibleStore = proxy<{ ids: string[] }>({ ids: [] });

export function setWallVisible(ids: readonly string[]) {
	wallVisibleStore.ids = [...ids];
}

export function clearWallVisible() {
	wallVisibleStore.ids = [];
}
